import { Hero } from "../sections/Hero";
import { ValueStrip } from "../sections/TrustStrip";
import { Problem } from "../sections/Problem";
import { BigIdea } from "../sections/Shift";
import { CoreSolutions } from "../sections/CoreSolutions";
import { ProductGrid } from "../sections/ProductShowcase";
import { Ecosystem } from "../sections/Ecosystem";
import { EditorialMarquee } from "../sections/Marquee";
import { Benefits } from "../sections/Benefits";
import { HowItWorks } from "../sections/HowItWorks";
import { WhyDifferent } from "../sections/WhyDifferent";
import { WhoItsFor } from "../sections/WhoItsFor";
import { Offer } from "../sections/Offer";
import { Trust } from "../sections/Trust";
import { FAQ } from "../sections/FAQ";
import { FinalCTA } from "../sections/FinalCTA";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <ValueStrip />
      <Problem />
      <BigIdea />
      <CoreSolutions />
      <ProductGrid />
      <Ecosystem />
      <EditorialMarquee />
      <Benefits />
      <HowItWorks />
      <WhyDifferent />
      <WhoItsFor />
      <Offer />
      <Trust />
      <FAQ />
      <FinalCTA />
    </main>
  );
}
